export const getScheduleDate = (time: string, date: string): Date | undefined => {
	const hours = time ? parseInt(time.split(":")[0]) : 0;
	const minutes = time ? parseInt(time.split(":")[1]) : 0;

	return date && time ? new Date(new Date(date).setHours(hours, minutes)) : undefined;
};
